"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
const translate_1 = require("../../../../@inax/translate");
const motion_1 = require("./../../../motion/src/motion");
const domain_1 = require("../../../motion/src/domain");
const motionTexts_1 = require("../../../motion/src/motionTexts");
const converter_1 = require("../../../plc/src/converter");
let MotionComponent = class MotionComponent {
    constructor(_inaxMotion, _inaxTranslate, _route, _inaxMotionTexts) {
        this._inaxMotion = _inaxMotion;
        this._inaxTranslate = _inaxTranslate;
        this._route = _route;
        this._inaxMotionTexts = _inaxMotionTexts;
        this._connectionError = false;
        this._entriesPerPage = 8;
        this._neededHeaderVariables = ["Header.States.CheckSumInvalid", "Header.States.UpdateRequested", "Header.Commands.UpdateAllowed", "Header.Commands.AllSlotsLocked", "Header.Commands.NavigationLocked", "Header.Commands.SafeVersionInvalid"];
        this._viewMode = domain_1.ViewMode.Symbolic;
        this._unitDescription = "";
        this._motions = [];
        this._currentMotions = [];
        this._page = 1;
        this.firstPage = 1;
    }
    get connectionError() {
        return this._connectionError;
    }
    get unit() {
        return String(this._unit);
    }
    get unitDescription() {
        return this._unitDescription;
    }
    get motions() {
        return this._currentMotions;
    }
    get selectedMotion() {
        return this._selectedMotion;
    }
    get checkSumInvalid() {
        return this._checksumInvalid;
    }
    get updateRequested() {
        return this._updateRequested;
    }
    get updateAllowed() {
        return this._updateAllowed;
    }
    get allSlotsLocked() {
        return this._allSlotsLocked;
    }
    get navigationLocked() {
        return this._navigationLocked;
    }
    get safeVersionInvalid() {
        return this._safeVersionInvalid;
    }
    get viewMode() {
        return this._viewMode;
    }
    get stateViewIsVisible() {
        return this._stateViewIsVisible;
    }
    get isSymbolicViewState() {
        return this.viewMode == domain_1.ViewMode.Symbolic;
    }
    get numberOfPages() {
        return this._numberOfPages;
    }
    ngOnInit() {
        //subscribe to the services
        this._route.params.subscribe((params) => {
            //get parameters from route
            let plc = params["plc"] || "";
            let unit = params["unit"] || 0;
            let entries = params["entries"] || 8;
            let plcChanged = this._plcId != plc;
            let unitChanged = this._unit != unit;
            let entriesChanged = this._entriesPerPage != entries;
            // if parameters are changing, update page
            if (plcChanged || unitChanged || entriesChanged) {
                this._plcId = plc;
                this._unit = unit;
                this._entriesPerPage = entries;
                if (plcChanged)
                    this.createHeaderProxy();
                if (plcChanged || unitChanged)
                    this.determineMotions();
                else
                    this.filterMotions();
            }
        });
    }
    ngOnDestroy() {
        //unsubscribe from the services
        if (this._headerEventProxy != null)
            this._headerEventProxy.dispose();
    }
    onToggleViewMode() {
        if (this._viewMode == domain_1.ViewMode.Symbolic)
            this._viewMode = domain_1.ViewMode.Absolute;
        else
            this._viewMode = domain_1.ViewMode.Symbolic;
    }
    onToggleStateView() {
        this._stateViewIsVisible = !this._stateViewIsVisible;
    }
    onpageChanged(page) {
        if (this._page != page) {
            this._page = page;
            this.filterMotions();
        }
    }
    onActivateLine(motion) {
        this._selectedMotion = motion;
    }
    onDeactivateLine(motion) {
        if (this._selectedMotion == motion)
            this._selectedMotion = null;
    }
    createHeaderProxy() {
        try {
            this._connectionError = false;
            if (this._headerEventProxy != null) {
                this._headerEventProxy.dispose();
                this._headerEventProxy = null;
            }
            this._headerEventProxy = this._inaxMotion.createSafeBlockHeaderProxy(this._plcId, this._neededHeaderVariables);
            this._headerEventProxy.ChangeEvent.subscribe((dce) => this.updateProperties(dce), (error) => {
                console.warn("Attempt to join channel failed!", error);
            });
        }
        catch (error) {
            this._connectionError = true;
            console.warn("Attempt to join channel failed!", error);
        }
    }
    determineMotions() {
        return __awaiter(this, void 0, void 0, function* () {
            let motions = yield this._inaxMotion.getMotionsForBlockAsync(this._plcId, this._unit);
            this._numberOfPages = Math.floor(motions.length / this._entriesPerPage) + 1;
            this._motions = motions != null ? motions : [];
            this.updateUnitDescription();
            this.filterMotions();
        });
    }
    filterMotions() {
        let start = (this._page - 1) * this._entriesPerPage;
        let end = start + this._entriesPerPage;
        this._currentMotions = this._motions.slice(start, end);
    }
    updateProperties(dce) {
        try {
            if (this._inaxMotion.MappingName == dce.Mapping) {
                for (let [key, value] of converter_1.Converter.flatten(dce.Data)) {
                    if (key == "Header.States.CheckSumInvalid") {
                        this._checksumInvalid = value;
                    }
                    else if (key == "Header.States.UpdateRequested") {
                        this._updateRequested = value;
                    }
                    else if (key == "Header.Commands.UpdateAllowed") {
                        this._updateAllowed = value;
                    }
                    else if (key == "Header.Commands.AllSlotsLocked") {
                        this._allSlotsLocked = value;
                    }
                    else if (key == "Header.Commands.NavigationLocked") {
                        this._navigationLocked = value;
                    }
                    else if (key == "Header.Commands.SafeVersionInvalid") {
                        this._safeVersionInvalid = value;
                    }
                }
            }
        }
        catch (error) {
            console.warn(`Error updateing data! ${error}`);
        }
    }
    updateUnitDescription() {
        if (this._motions.length > 0) {
            this._unitDescription = this._motions[0].MappingName.split(".")[0];
        }
        else {
            this._unitDescription = "";
        }
    }
};
MotionComponent = __decorate([
    core_1.Component({
        selector: 'motion',
        templateUrl: './@inax/motionUi/src/motion/motion.component.html',
        styleUrls: ['./@inax/motionUi/src/motion/motion.component.css']
    }),
    __metadata("design:paramtypes", [motion_1.InaxMotionService,
        translate_1.InaxTranslateService,
        router_1.ActivatedRoute,
        motionTexts_1.InaxMotionTextsService])
], MotionComponent);
exports.MotionComponent = MotionComponent;
